import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LocalStorageService } from 'src/app/Model/Common/LocalStorageService';
import { RiderDetails } from 'src/app/Model/Rider/rider-details';
import { AppConfigService } from 'src/app/Service/Configuration/app-config.service';
import { RiderService } from 'src/app/Service/Rider/rider.service';
import { environment } from 'src/environments/environment';
import { logOutApp } from 'src/myfunc';

@Component({
  selector: 'app-pre-app-android',
  templateUrl: './pre-app-android.component.html',
  styleUrls: ['./pre-app-android.component.css']
})
export class PreAppAndroidComponent {
  riderDetails: RiderDetails;
  rider_email: string
  private getRiderSubscription: Subscription;
  constructor(public persistenceService: LocalStorageService,
    private router: Router,
    private riderService: RiderService,
    private appConfig: AppConfigService
  ) {
    this.rider_email = this.getQueryVariable("rider_email");

  }
  ngOnInit() {

    this.rider_email = this.getQueryVariable("rider_email");
    this.persistenceService.set("google_email", this.rider_email);
    if (this.persistenceService.get("google_item") == null || this.persistenceService.get("google_item") == undefined)
      this.persistenceService.set("google_item", "NA");
    console.log("Received Query Value=" + this.rider_email);
    if (this.rider_email == "NA")
      logOutApp()
    else
      this.getRiderByEmail(this.rider_email)
    // this.riderDetails = new RiderDetails();
    // this.riderDetails.refNo = Number(data.split("===")[0]);
    // this.riderDetails.firstName = data.split("===")[1];
    // this.riderDetails.lastName = data.split("===")[2];
    // this.riderDetails.mobileNo = data.split("===")[3];
    // this.riderDetails.email = data.split("===")[4];
    // this.riderDetails.dob = data.split("===")[5];
    // this.riderDetails.education = data.split("===")[6];
    // this.riderDetails.vehicleType = data.split("===")[7];
    // this.riderDetails.vehicleNo = data.split("===")[8];
    // this.riderDetails.vehicleName = data.split("===")[9];
    // this.riderDetails.vehicleRegNo = data.split("===")[10];
    // this.riderDetails.aadhaarNo = data.split("===")[11];
    // this.riderDetails.riderSelfiePath = data.split("===")[12];
    // this.riderDetails.fromLocationCode = Number(data.split("===")[13]);
    // if (data.split("===")[14] == 'true')
    //   this.riderDetails.activeStatus = true;
    // else 
    //   this.riderDetails.activeStatus = false;
    // if (data.split("===")[15] == 'true') 
    //   this.riderDetails.isVerified = true;
    // else 
    //   this.riderDetails.isVerified = false;
    // this.riderDetails.aadhaarImagePath = data.split("===")[16];
    // this.persistenceService.set('google_item',this.riderDetails.email);
    // this.persistenceService.set('google_email',this.riderDetails.email);
    // this.persistenceService.set('rider_details',JSON.stringify(this.riderDetails));
    // if (this.riderDetails.email != '') 
    //   this.router.navigateByUrl('dashboard');
    // else 
    //   this.router.navigateByUrl('rider-details');

  }

  getRiderByEmail(googleEmailId: string) {
    this.getRiderSubscription = this.riderService.getRiderByEmail(googleEmailId).subscribe((data) => {
      console.log("Data==" + data)
      if (data) {
        this.riderDetails = data;
        this.persistenceService.set("rider_details", JSON.stringify(this.riderDetails));
        this.persistenceService.set('locId', JSON.stringify(this.riderDetails.fromLocationCode));
        this.persistenceService.set("active_rider_status", this.riderDetails.activeStatus ? 'true' : 'false');
        this.persistenceService.set("google_item", JSON.stringify(this.riderDetails.firstName + " " + this.riderDetails.lastName));
        this.persistenceService.set('google_email', JSON.stringify(this.riderDetails.email))
        this.persistenceService.set('page', 'Dashboard');
        window.location.href = this.appConfig.setting.baseURL + '/dashboard';
        //window.location.reload();
      }
      else {
        console.log("No Data==" + data)
        //window.location.href=environment.baseURL+'/rider-details';
        this.router.navigateByUrl('rider-details');
        this.persistenceService.set('page', 'Rider Details');
      }
      //window.location.reload();
    });
  }


  getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    console.log("Received Query Value1=" + query)
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (pair[0] == variable) {
        return pair[1].replaceAll('%20', ' ');
      }
    }
  }
}
